export default __webpack_public_path__ + "static/media/May2020.cd4dac8e.png";